export default __webpack_public_path__ + "static/media/backspace.6af3ef42.svg";